$(document).ready(function(){

	var options = {
		easing: 'easeInOut',
		autoplay: true,
		autoplaySpeed: 10000,
		arrows: false,
		pauseOnDotsHover: false,
		pauseOnHover: false,
		pauseOnFocus: false
	};

	$('.introbuehne .illus').slick($.extend({},options,{
		asNavFor: '.contents',
		speed: 800,
		dots: true,
		appendDots: '.introbuehne .dots'
	}));

	$('.introbuehne .contents').slick($.extend({},options,{
		asNavFor: '.illus',
		speed: 500,
		fade: true,
	}));

});
